import { TransferGiftCardModal } from 'components/gift-card-modal/transfer-gift-card';

export default function AddGiftCard() {
  return <TransferGiftCardModal />;
}
